module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('h3', {
    staticClass: "text-muted"
  }, [_vm._v("Twitter Stream")]), _vm._v(" "), (_vm.mode === 'stream') ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.streaming
    },
    on: {
      "click": function($event) {
        _vm.changeMode('options')
      }
    }
  }, [_vm._v("Options Menu\n        ")]) : _vm._e()]), _vm._v(" "), _c('options-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode === 'options'),
      expression: "mode === 'options'"
    }],
    attrs: {
      "language": _vm.language,
      "save-stream-settings": _vm.saveStreamSettings,
      "set-language": _vm.setLanguage,
      "set-track-string": _vm.setTrackString,
      "track-string": _vm.trackString
    }
  }), _vm._v(" "), (_vm.mode === 'stream') ? _c('stream-menu', {
    attrs: {
      "connecting-stream": _vm.connectingStream,
      "created-at": _vm.createdAt,
      "filter-array": _vm.filterArray,
      "filter-string": _vm.filterString,
      "language": _vm.language,
      "start-stream": _vm.startStream,
      "set-filter-string": _vm.setFilterString,
      "status-list-length": _vm.statusListLength,
      "stop-stream": _vm.stopStream,
      "streaming": _vm.streaming,
      "track-string": _vm.trackString
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode === 'stream'),
      expression: "mode === 'stream'"
    }],
    staticClass: "tweet-container"
  }, _vm._l((_vm.filterArray), function(status, i) {
    return _c('tweet', {
      key: i,
      attrs: {
        "status": status
      }
    })
  })), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "container footer"
  }, [_c('p', [_vm._v("Built with Vue.js, Node.js and Socket.io by\n            "), _c('a', {
    attrs: {
      "href": "https://dominicserrano.com"
    }
  }, [_vm._v("Dominic Serrano")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07c1b177","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 23
// module chunks = 0